import React from 'react';
import PropTypes from 'prop-types';
import { reactLocalStorage } from 'reactjs-localstorage';

const OptionsButton = props => {
  const { icon, text, action, clickFunction, changeConfiguratorMode, goToMode } = props;
  const handleClick = () => {
    clickFunction(action);
    if (changeConfiguratorMode && goToMode) {
      changeConfiguratorMode(goToMode);
    }
    if (action === 'edit') {
      reactLocalStorage.setObject('copyWardrobe', reactLocalStorage.getObject('wardrobesConfigs'));
    }
  };

  return (
    <button className="options__btn" onClick={handleClick}>
      <span className={`icon-${icon} navButtons__icon`} />
      <span className="options__btn--text">{text}</span>
    </button>
  );
};

OptionsButton.propTypes = {
  text: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  clickFunction: PropTypes.func.isRequired,
  action: PropTypes.string,
  changeConfiguratorMode: PropTypes.func,
  goToMode: PropTypes.number,
};

export default OptionsButton;
